import { styled } from "@mui/material/styles"
import { Box, Chip } from "@mui/material"

export const StyledContainer = styled(Box)(({ theme }) => ({
  // padding: theme.spacing(2),
}))

export const StyledSearchBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  alignItems: "center"
}))

export const StyledStatusChip = styled(Chip)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "0.75rem"
}))
